// src/services/approveMissionClaim.js
import { doc, runTransaction, serverTimestamp, increment, collection } from 'firebase/firestore' // ✨ PERBAIKAN: Tambahkan 'collection'
import { db } from '../firebaseConfig'

/**
 * APPROVE CLAIM MISSION
 * - Validasi status
 * - Tambah saldo mitra
 * - Tandai claim sebagai approved
 */
export async function approveMissionClaim({
  claimId,
  mitraId,
  mitraType, // 'cleaner' | 'therapist'
  missionId,
  missionScope, // 'daily' | 'weekly'
  bonus,
}) {
  const mitraRef = doc(db, `${mitraType}s`, mitraId)
  const claimRef = doc(db, 'mission_claim_logs', claimId)
  const missionRef = doc(
    db,
    `${mitraType}s`,
    mitraId,
    `missions_${missionScope}`,
    missionId
  )

  await runTransaction(db, async (tx) => {
    const claimSnap = await tx.get(claimRef)
    if (!claimSnap.exists()) {
      throw new Error('Claim tidak ditemukan')
    }

    const claim = claimSnap.data()
    if (claim.status === 'approved') {
      throw new Error('Claim sudah disetujui')
    }

    // 1️⃣ Tambah saldo mitra
    tx.update(mitraRef, {
      saldo: increment(Number(bonus)), 
    })

    // ✨ BARU: Tambahkan riwayat saldo agar muncul di aplikasi Mitra
    const historyRef = doc(collection(db, `${mitraType}s/${mitraId}/saldo_history`))
    tx.set(historyRef, {
      type: 'credit',
      amount: Number(bonus),
      description: 'Pencairan Bonus Misi',
      missionId: missionId,
      timestamp: serverTimestamp(),
    })

    // 2️⃣ Tandai mission selesai secara penuh (opsional, karena di Flutter sudah diset true)
    tx.update(missionRef, {
      claimed: true,
      claimedAt: serverTimestamp(),
    })

    // 3️⃣ Update log claim
    tx.update(claimRef, {
      approved: true, // ✨ PERBAIKAN: Agar hilang dari daftar pending
      status: 'approved',
      approvedAt: serverTimestamp(),
    })
  })
}
